export default __webpack_public_path__ + "static/wubssz_Logo_Web-7c82110ba6caae4bc6089b9c5f0f1614.jpeg";